
export class GatePassDetails {
  gatePassID!: number;
  purpose!: string;
  reference!: string;
  vehicleNo!: string;
  driverName!: string;
  driverPhone!: string;
  planned_Gate!: string;
  planned_GateOut!: string;
  planned_Dock!: string;
  validFrom!: Date;
  validTo!: Date;
}
